export default __webpack_public_path__ + "static/media/6.774b26e3.webp";